import React from 'react';
import { Group } from 'components';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_GROUPS_STORE } from 'store';
import { GroupViewContentProps } from './types';

const GroupViewContent = (props: GroupViewContentProps) => {
  const {
    [EDITOR_GROUPS_STORE]: {
      sortedGroupsByPreviewFrame
    }
  } = props;

  return (
    <>
      {sortedGroupsByPreviewFrame.map(group =>
        <Group
          key={group.name}
          {...group}
          disableNameEdit
          singleSelect
        />
      )}
    </>
  );
};

export default inject(EDITOR_GROUPS_STORE)(observer(GroupViewContent));
